import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        // 에러 정보를 sessionStorage에 저장
        const errorData = {
            message: error.message || '알 수 없는 오류가 발생했습니다.',
            stack: errorInfo.componentStack,
            timestamp: new Date().toISOString(),
            location: window.location.pathname,
            componentName: errorInfo.componentStack
            .split('\n')[1]
            ?.trim()
            ?.split(' ')[1] || 'Unknown'
        };

        // 개발 환경에서만 콘솔 출력
        if (process.env.NODE_ENV === 'development') {
            // console.error('Error caught in ErrorBoundary:', error);
            // console.error('Component Stack:', errorInfo.componentStack);
        }

        sessionStorage.setItem('errorData', JSON.stringify(errorData));
        this.props.navigate('/error');
    }

    render() {
        if (this.state.hasError) {
            // return null;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node,
    navigate: PropTypes.func.isRequired
};

function ErrorBoundaryWithRouter({children}) {
    const navigate = useNavigate();
    return <ErrorBoundary navigate={navigate}>{children}</ErrorBoundary>;
}

ErrorBoundaryWithRouter.propTypes = {
    children: PropTypes.node
};

export default ErrorBoundaryWithRouter;